/**
 * Add drag ability to a model
 */

import SVG from 'svg.js';

export interface ResizableRequirements {
  attributes: Record<string, any>;
  view: SVG.G;
}

export const ResizableMixin = <T extends { new (...args: any[]): ResizableRequirements }>(base: T) => {
  return class ResizableMixin extends base {
    scale: number = 1;

    onResize(scale: number) {
      this.scale = scale;
      if (!scale) {
        this.scale = this.attributes.scale;
      }
      this.attributes.scale = this.scale;
      this.view.transform({ scale: this.scale });
    }

    onResizeEnd() {
      this.attributes.scale = this.scale;
      this.view.transform({ scale: this.scale });
    }
  };
};
